<template>
  <div class="time-picker-wrapper">
    <div class="time-picker-inputs">
      <div class="time-input-group">
        <b-form-input
          :id="`${inputId}-hours`"
          v-model.number="hours"
          type="number"
          min="0"
          :max="maxHours"
          :placeholder="hoursPlaceholder"
          class="time-input"
          :disabled="disabled"
          @input="updateValue"
          @blur="validateHours"
        />
        <label :for="`${inputId}-hours`" class="time-label">{{ hoursLabel }}</label>
      </div>
      <span class="time-separator">:</span>
      <div class="time-input-group">
        <b-form-input
          :id="`${inputId}-minutes`"
          v-model.number="minutes"
          type="number"
          min="0"
          max="59"
          :placeholder="minutesPlaceholder"
          class="time-input"
          :disabled="disabled"
          @input="updateValue"
          @blur="validateMinutes"
        />
        <label :for="`${inputId}-minutes`" class="time-label">{{ minutesLabel }}</label>
      </div>
    </div>
    <div v-if="showTotalMinutes && totalMinutes > 0" class="total-minutes-display">
      Total: {{ totalMinutes }} minute{{ totalMinutes !== 1 ? 's' : '' }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimePicker',
  props: {
    // Value in minutes
    value: {
      type: Number,
      default: null,
    },
    inputId: {
      type: String,
      default: 'time-picker',
    },
    hoursLabel: {
      type: String,
      default: 'Hours',
    },
    minutesLabel: {
      type: String,
      default: 'Minutes',
    },
    hoursPlaceholder: {
      type: String,
      default: 'HH',
    },
    minutesPlaceholder: {
      type: String,
      default: 'MM',
    },
    maxHours: {
      type: Number,
      default: 99,
    },
    showTotalMinutes: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hours: 0,
      minutes: 0,
    };
  },
  computed: {
    totalMinutes() {
      const h = parseInt(this.hours) || 0;
      const m = parseInt(this.minutes) || 0;
      return h * 60 + m;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue !== null && newValue !== undefined) {
          this.hours = Math.floor(newValue / 60);
          this.minutes = newValue % 60;
        } else {
          this.hours = 0;
          this.minutes = 0;
        }
      },
    },
  },
  methods: {
    updateValue() {
      // Emit total minutes or null if both are 0
      const total = this.totalMinutes;
      this.$emit('input', total > 0 ? total : null);
    },
    validateHours() {
      if (this.hours < 0) this.hours = 0;
      if (this.hours > this.maxHours) this.hours = this.maxHours;
      this.updateValue();
    },
    validateMinutes() {
      if (this.minutes < 0) this.minutes = 0;
      if (this.minutes > 59) this.minutes = 59;
      this.updateValue();
    },
  },
};
</script>

<style scoped>
.time-picker-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.time-picker-inputs {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

.time-input-group {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
  max-width: 80px;
}

.time-input {
  text-align: center;
  font-size: 0.875rem;
  font-weight: 400;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.5rem;
}

/* Remove spinner arrows for Chrome, Safari, Edge, Opera */
.time-input::-webkit-outer-spin-button,
.time-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Remove spinner arrows for Firefox */
.time-input[type='number'] {
  -moz-appearance: textfield;
}

.time-label {
  font-size: 0.7rem;
  color: #6c757d;
  text-align: center;
  margin: 0;
  font-weight: 500;
  line-height: 1;
}

.time-separator {
  font-size: 1.25rem;
  font-weight: 500;
  color: #495057;
  margin-top: 0.25rem;
}

.total-minutes-display {
  font-size: 0.875rem;
  color: #6c757d;
  font-style: italic;
  margin-top: -0.25rem;
}
</style>

